import { createRoot } from "react-dom/client";
import { startClientTelemetry } from "./lib/telemetry";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { createQueryClient } from "./lib/query-client";
import { expireSession } from "./lib/session";
import { startTheme } from "./lib/theme";
import { createAppRouter } from "./router";

/**
 * Before anything renders: the reader's own skin, if they have chosen one.
 * index.html paints the attribute earlier still, from storage, so this call is
 * the one that seeds the store the /you switcher reads back.
 */
startTheme();

/**
 * The two things the app is: a set of addresses, and a cache of the server.
 *
 * They are wired together here and only here. The router carries the query
 * client in its context, so a route can warm what its screen is about to read
 * before the screen renders; the query client carries the router, so the one
 * answer to a lost session — go home and say why — is written once rather than
 * threaded through every screen that can meet a 401.
 */
const queryClient = createQueryClient(() =>
  expireSession(queryClient, () => void router.navigate({ to: "/", search: {} })),
);

const router = createAppRouter(queryClient);

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

startClientTelemetry();

createRoot(root).render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
  </QueryClientProvider>,
);
